// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.contacts.RentalManagerUserPropertyContactsWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerUserPropertyContactsWebApiHandler_getCountForListings,
  RentalManagerUserPropertyContactsWebApiHandler_getCountForListings_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  GetContactCountForListingsRequestWebDto,
  UserPropertiesLeadCountDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export type RentalManagerUserPropertyContactsWebApiHandler_getCountForListings_Options = UseQueryOptions<
  Array<UserPropertiesLeadCountDto>,
  unknown,
  Array<UserPropertiesLeadCountDto>,
  Array<string | GetContactCountForListingsRequestWebDto>
>;

const RentalManagerUserPropertyContactsWebApiHandler_getCountForListings_GetKey = (
  postData: GetContactCountForListingsRequestWebDto,
) => [RentalManagerUserPropertyContactsWebApiHandler_getCountForListings_Path, postData];

/**
 * Get contact count for listings given a list of listing aliases
 */
export const useRentalManagerUserPropertyContactsWebApiHandler_getCountForListings = (
  postData: GetContactCountForListingsRequestWebDto,
  options: Omit<
    RentalManagerUserPropertyContactsWebApiHandler_getCountForListings_Options,
    'queryFn' | 'queryKey'
  > = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerUserPropertyContactsWebApiHandler_getCountForListings_GetKey(postData),
    queryFn: () => RentalManagerUserPropertyContactsWebApiHandler_getCountForListings(postData),
  });
};
useRentalManagerUserPropertyContactsWebApiHandler_getCountForListings.getKey =
  RentalManagerUserPropertyContactsWebApiHandler_getCountForListings_GetKey;
